export const PickStatus = {
    ASSIGNABLE: "ASSIGNABLE",
    ASSIGNED: "ASSIGNED",
    IN_PROGRESS: "IN_PROGRESS",
    PRE_STAGED: "PRE_STAGED",
    COMPLETED: "COMPLETED",
    isComplete: (pickStatus) => {
        return PickStatus.COMPLETED === pickStatus || PickStatus.PRE_STAGED === pickStatus;
    }
}



// WEBPACK FOOTER //
// ./src/models/enums/pick-enums.js